import { render, staticRenderFns } from "./TabelaBase.vue?vue&type=template&id=06ef79ad&scoped=true"
import script from "./TabelaBase.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaBase.vue?vue&type=style&index=0&id=06ef79ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef79ad",
  null
  
)

export default component.exports